import { Controller } from "@hotwired/stimulus"

// Polls the watchlist status endpoint while the company + competitors resolve in
// the background. Reloads the page (→ the selection form) once ready, and has a
// hard timeout escape so a stalled enrichment never traps the user on the
// loading screen — it reloads with ?ready=1, which the server honors.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 },
    timeout: { type: Number, default: 30000 },
  }

  connect() {
    this.deadline = Date.now() + this.timeoutValue
    this.timer = setInterval(() => this.tick(), this.intervalValue)
    this.monitoringIntentStateHandler = () => this.resumePendingFinish()
    document.addEventListener("monitoring-intent:state", this.monitoringIntentStateHandler)
    this.tick()
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
    document.removeEventListener("monitoring-intent:state", this.monitoringIntentStateHandler)
  }

  async tick() {
    if (Date.now() > this.deadline) return this.finish(true)
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const data = await res.json()
      if (data.ready) this.finish(false)
    } catch (_e) {
      // transient network blip — keep polling until the deadline
    }
  }

  finish(timedOut) {
    clearInterval(this.timer)
    this.pendingFinishTimedOut ||= timedOut
    if (!this.monitoringIntentReady()) return

    this.navigate(this.pendingFinishTimedOut)
  }

  resumePendingFinish() {
    if (this.pendingFinishTimedOut === undefined || !this.monitoringIntentReady()) return

    this.navigate(this.pendingFinishTimedOut)
  }

  monitoringIntentReady() {
    const controller = document.querySelector('[data-controller~="monitoring-intent"]')
    return !controller || controller.dataset.monitoringIntentState === "idle"
  }

  navigate(timedOut) {
    this.pendingFinishTimedOut = undefined
    const url = new URL(window.location.href)
    if (timedOut) url.searchParams.set("ready", "1")
    window.location.assign(url.toString())
  }
}
